import { Avatar as PrimitiveAvatar } from "@ark-ui/react/avatar";
import { cn } from "@base/lib/utils";

interface AvatarProps {
  fallback?: string;
  img?: string;
  className?: string;
}

export const Avatar = ({ fallback, img, className }: AvatarProps) => {
  return (
    <PrimitiveAvatar.Root
      className={cn(
        "inline-flex items-center justify-center w-6 h-6 overflow-hidden text-xs text-white leading-none tracking-[-0.24px] rounded-full bg-maruGreen",
        className,
      )}
    >
      {img ? (
        <PrimitiveAvatar.Image src={img} alt="avatar" className="object-cover w-full h-full" />
      ) : (
        <PrimitiveAvatar.Fallback className="inline-flex justify-center items-center">
          {fallback}
        </PrimitiveAvatar.Fallback>
      )}
    </PrimitiveAvatar.Root>
  );
};

Avatar.displayName = "Avatar";
